import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import useCustomContactCTA from "../../hooks/useCustomContactCTA";
import Button from "../button/Button";
import scaleIcon from "../../images/scala.svg";

const defaultContactCTAData = {
  title: "Ready to make your SaaS Scalable?",
  description: "Fix most important issues within days from the kick-off",
  btnText: "CONTACT US",
  btnLink: "https://accesto.com/contact/",
};

function Contact({ className }) {
  const customContactCTA = useCustomContactCTA();

  const contactClassName = classnames("contact", className);

  const title = customContactCTA?.title || defaultContactCTAData.title;
  const description = customContactCTA?.description || defaultContactCTAData.description;
  const btnLink = customContactCTA?.btnLink || defaultContactCTAData.btnLink;
  const btnText = customContactCTA?.btnText || defaultContactCTAData.btnText;
  const icon = customContactCTA?.iconPath || scaleIcon;

  return (
    <div className={contactClassName}>
      <div className="contact__icon">
        <img src={icon} alt="icon" className="contact__icon__image" />
        <div className="contact__icon__border"></div>
      </div>
      <h2>{title}</h2>
      <p className="contact__text">
        {description}
      </p>
      <Button primary href={btnLink}>
        {btnText}
      </Button>
    </div>
  );
}

Contact.propTypes = {
  className: PropTypes.string,
};

export default Contact;
